import { Product } from '../../types';

export const sheetTerminalsProducts: Product[] = [
  {
    id: "bt-sheet-sbt011311",
    name: "Brass Sheet Terminal - Tata Ace (Negative & Positive) (SBT011311)",
    slug: "brass-sheet-terminal-tata-ace-negative-positive-sbt011311",
    category: "Brass Terminal",
    subcategory: "Sheet Terminals",
    description: "Brass sheet terminal set suitable for Tata Ace, includes both negative and positive terminals with bolt and nut assembly. C-shaped design for secure battery connections.",
    partNumber: "SBT011311",
    specifications: {
      "Description": "Suitable for : Tata Ace (Negative & Positive)",
      "Material": "CuZn-63/37",
      "Standard Packing": "Cut-12 Pcs.",
      "Terminal Height": "49.00 mm",
      "Type": "C-Shaped Sheet Terminal",
    },
    images: ["/products/brass-terminals/sheet-terminals/SBT011311.jpg"],
    tags: ["terminal", "sheet", "brass", "tata ace", "battery terminal", "negative", "positive"],
    applications: ["Automotive", "Battery Connections", "Tata Ace"],
  },
  {
    id: "bt-sheet-sbt011312",
    name: "Brass Sheet Terminal - Tata Sumo (Negative & Positive) (SBT011312)",
    slug: "brass-sheet-terminal-tata-sumo-negative-positive-sbt011312",
    category: "Brass Terminal",
    subcategory: "Sheet Terminals",
    description: "Brass sheet terminal set suitable for Tata Sumo, includes both negative and positive terminals with bolt and nut assembly. L-shaped base design for enhanced mounting.",
    partNumber: "SBT011312",
    specifications: {
      "Description": "Suitable for : Tata Sumo (Negative & Positive)",
      "Material": "CuZn-63/37",
      "Standard Packing": "Cut-12 Pcs.",
      "Terminal Height": "56.00-56.50 mm",
      "Base Width": "29.00-29.10 mm",
      "Type": "C-Shaped Sheet Terminal with L-Base",
    },
    images: ["/products/brass-terminals/sheet-terminals/SBT011312.jpg"],
    tags: ["terminal", "sheet", "brass", "tata sumo", "battery terminal", "negative", "positive"],
    applications: ["Automotive", "Battery Connections", "Tata Sumo"],
  },
  {
    id: "bt-sheet-sbt011313",
    name: "Brass Sheet Terminal - Tata Sumo (Negative & Positive) (SBT011313)",
    slug: "brass-sheet-terminal-tata-sumo-negative-positive-sbt011313",
    category: "Brass Terminal",
    subcategory: "Sheet Terminals",
    description: "Brass sheet terminal set suitable for Tata Sumo, includes both negative and positive terminals with bolt and nut assembly. Open C-shaped design with marked polarity.",
    partNumber: "SBT011313",
    specifications: {
      "Description": "Suitable for : Tata Sumo (Negative & Positive)",
      "Material": "CuZn-63/37",
      "Standard Packing": "Cut-12 Pcs.",
      "Terminal Height": "56.50 mm",
      "Internal Opening Height": "19.20-19.50 mm",
      "Type": "C-Shaped Sheet Terminal with Polarity Marking",
    },
    images: ["/products/brass-terminals/sheet-terminals/SBT011313.jpg"],
    tags: ["terminal", "sheet", "brass", "tata sumo", "battery terminal", "negative", "positive", "polarity marked"],
    applications: ["Automotive", "Battery Connections", "Tata Sumo"],
  },
];
